import { UntypedFormGroup, UntypedFormControl, Validators, AsyncValidatorFn, AbstractControl } from '@angular/forms';
import { AddressType } from '../../../models/enums/address-type.enum';

export class AuthorForm extends UntypedFormGroup {
  constructor() {
    super({
      id: new UntypedFormControl(null),
      firstName: new UntypedFormControl(null, [Validators.required]),
      lastName: new UntypedFormControl(null, [Validators.required]),

      inhabitantAddress: new UntypedFormGroup({
        id: new UntypedFormControl(),
        addressType: new UntypedFormControl(AddressType.Inhabitant),
        country: new UntypedFormControl(),
        city: new UntypedFormControl(),
        postCode: new UntypedFormControl(),
        street: new UntypedFormControl(),
        houseNumber: new UntypedFormControl(),
        apartmentNumber: new UntypedFormControl(),
      }),
      correspondenceAddress: new UntypedFormGroup({
        id: new UntypedFormControl(),
        addressType: new UntypedFormControl(AddressType.Correspondence),
        country: new UntypedFormControl(),
        city: new UntypedFormControl(),
        postCode: new UntypedFormControl(),
        street: new UntypedFormControl(),
        houseNumber: new UntypedFormControl(),
        apartmentNumber: new UntypedFormControl(),
      }),
    });
  }

  forAdd() {
    return this;
  }
}
